import { Brain, MessageCircle, Briefcase, Gauge, Users, TrendingUp } from 'lucide-react';

export default function EvaluationEngine() {
  return (
    <section className="py-32 bg-transparent overflow-hidden relative">

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-96 h-96 bg-emerald-500 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative h-96 flex items-center justify-center">
            <div className="absolute inset-0 bg-emerald-500/5 blur-[100px] rounded-full"></div>
            <div className="w-80 h-80 rounded-full border border-white/10 relative flex items-center justify-center">
              <div className="absolute w-full h-full rounded-full border-2 border-transparent border-t-emerald-500 animate-spin" style={{ animationDuration: '20s' }}></div>

              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black border border-white/20 px-3 py-1 rounded-full text-xs font-mono text-emerald-500">
                INTERVIEW
              </div>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-black border border-white/20 px-3 py-1 rounded-full text-xs font-mono text-teal-500">
                SCORE
              </div>
              <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black border border-white/20 px-3 py-1 rounded-full text-xs font-mono text-white uppercase tracking-tighter">
                POTENTIAL
              </div>
              <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 bg-black border border-white/20 px-3 py-1 rounded-full text-xs font-mono text-white">
                PASSPORT
              </div>

              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-emerald-500/20 to-black border border-emerald-500/50 flex items-center justify-center text-center p-4 shadow-[0_0_30px_rgba(0,210,106,0.2)]">
                <span className="text-xs font-bold tracking-widest text-white">
                  EVALUATION<br />ENGINE
                </span>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
                The Evaluation Engine
              </h2>
              <p className="text-lg text-slate-300">
                Every AI tool can ask questions. Only GreenTick can understand{' '}
                <em className="text-white">how humans think</em>.
              </p>
            </div>

            <div className="glass-dark p-8 rounded-xl border-l-4 border-l-emerald-500">
            <h3 className="text-white font-bold mb-4">
                We don't capture answers — we capture human potential:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-slate-300">
                <div className="flex gap-2 items-center">
                  <Brain className="w-4 h-4 text-emerald-500" />
                  Reasoning patterns
                </div>
                <div className="flex gap-2 items-center">
                  <MessageCircle className="w-4 h-4 text-emerald-500" />
                  Communication clarity
                </div>
                <div className="flex gap-2 items-center">
                  <Briefcase className="w-4 h-4 text-emerald-500" />
                  Role-specific thinking
                </div>
                <div className="flex gap-2 items-center">
                  <Gauge className="w-4 h-4 text-emerald-500" />
                  Pressure handling
                </div>
                <div className="flex gap-2 items-center">
                  <Users className="w-4 h-4 text-emerald-500" />
                  Cultural fit signals
                </div>
                <div className="flex gap-2 items-center">
                  <TrendingUp className="w-4 h-4 text-emerald-500" />
                  Future intent
                </div>
              </div>
            </div>
            <p className="text-white font-bold">
              This compounding potential dataset becomes our permanent moat.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
